import type { VenueDetail, VenuePatch } from '../../../../api/venues';

export const grid2 = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 } as const;

/** Blank input becomes null so an emptied field clears the stored value. */
export const nullable = (s: string) => (s.trim().length === 0 ? null : s.trim());

export interface SectionProps {
  venue: VenueDetail;
  readOnly: boolean;
  save: (patch: VenuePatch) => Promise<void>;
}
